export var RequiredDocumentsHeadingEnum;
(function (RequiredDocumentsHeadingEnum) {
    RequiredDocumentsHeadingEnum["type"] = "Type";
    RequiredDocumentsHeadingEnum["name"] = "Name";
    RequiredDocumentsHeadingEnum["dateUploaded"] = "Date uploaded";
    RequiredDocumentsHeadingEnum["fileName"] = "File name";
})(RequiredDocumentsHeadingEnum || (RequiredDocumentsHeadingEnum = {}));
